<template>
    <div 
        id="contact" 
        class="contact d-flex my-10"
    >
        <v-row class="pa-0 mx-0 my-10">
            <v-col 
                :class="`${ imgPosition === 'right' ? 'order-last' : 'order-first' }${ $mq.phone ? ' d-none' : '' }`"
                class="content-image"
                :style="{ backgroundImage: `url(${ image })` }"
                cols="5"
            />
            
            <v-col 
                :cols="!$mq.phone ? '7' : '12'"
                class="d-flex align-center pa-0"     
                :style="$mq.phone ? { backgroundImage: `url(${ image })`, backgroundSize: 'cover', backgroundPosition: 'center' } : '' "           
            >
                <div
                    class="fill-height d-flex align-center content-card px-10 py-5"
                    :class="$mq.phone ? 'semi-gray' : 'transparent'"
                >
                    <v-card
                        flat
                        color="transparent"
                        class="content-card"
                        :class="`${ imgPosition === 'right' ? 'text-right' : 'text-left' }`"
                    >
                        <v-card-title 
                            class="d-flex"
                            :class="`${ !!$mq.phone ? ' justify-center' : imgPosition === 'right' ? 'justify-end' : 'justify-start' }`"
                        >
                            <h2 :class="`${ textColor } ${ $mq.phone ? '' : !!$mq.tablet ? 'display-1' : 'display-2' }`">{{ title }}</h2>
                        </v-card-title>

                        <ContactForm :embedded="true" />

                        <v-card-text>
                            <h4>...ou écrivez-nous à</h4>
                            <h3>{{ email.toUpperCase() }}</h3>
                        </v-card-text>
                    </v-card>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ContactForm from '@/components/ContactForm'

export default {
    name: 'Contact',
    components: {
        ContactForm,
    },
    props: [
        'imgPosition',
    ],
    computed: {
        image() {
            return require(`@/assets/img/contact-us-${ !!this.$mq.phone ? 'sm' : 'md' }.jpg`)
        },
        textColor() {
            return !!this.$mq.phone ? 'custom-white-text' : 'custom-gray-text'
        },
    },
    data() {
        return {
            email: process.env.VUE_APP_EMAIL,
            title: `Nous joindre`,
        }
    },
    methods: {    
        run(method, params = null) {
            if(typeof this[method] === 'function') {
                !!params ? this[method](params) : this[method]()
            }
            else {
                this.$emit('run', method, params)
            }
        },
    },
}
</script>

<style scoped> 
.contact {
    min-height: 50vh;
}

.content-image {
    background-size: cover;
    background-position: center;
}

.v-card__title > * {
    word-break: normal;
}

.content-card {
    width: 100%;
}
</style>
